import pixel from './pixel'
import gallery from './gallery'
import meta from './meta'

export default {
  ...pixel,
  ...gallery,
  ...meta
}
